import { render, staticRenderFns } from "./ProductHardware.vue?vue&type=template&id=66ec323a&scoped=true&"
import script from "./ProductHardware.vue?vue&type=script&lang=js&"
export * from "./ProductHardware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ec323a",
  null
  
)

export default component.exports